import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { FireLayerNotifier } from './fire-layer-notifier';
import { FireLayerState } from './fire-layer-state';

@Injectable()
export class FireLayerProvider extends BaseProvider<FireLayerNotifier, FireLayerState> {
  constructor() {
    super(FireLayerNotifier);
  }
}
